import { render } from "./AccountSettings.vue?vue&type=template&id=2fb9e46a&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"

import "./AccountSettings.vue?vue&type=style&index=0&id=2fb9e46a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb9e46a"]])

export default __exports__